import {
  gridExpandedSortedRowIdsSelector,
  gridFilteredSortedRowIdsSelector,
  selectedIdsLookupSelector,
} from "@mui/x-data-grid-premium";
import { GridApiPremium } from "@mui/x-data-grid-premium/models/gridApiPremium";
import { RefObject } from "react";
import { defined } from "./typeHelper";

export const selectNexRow = (apiRef: RefObject<GridApiPremium>) => selectRow(apiRef, 1);

export const selectPreviousRow = (apiRef: RefObject<GridApiPremium>) => selectRow(apiRef, -1);

const selectRow = (apiRef: RefObject<GridApiPremium>, direction: number) => {
  const selectedRowIds = [...apiRef.current.getSelectedRows().keys()];

  if (selectedRowIds.length !== 1) {
    return;
  }

  const selectedRowIndex = apiRef.current.getRowIndexRelativeToVisibleRows(defined(selectedRowIds[0]));
  if (selectedRowIndex === 0 && direction === -1) {
    return;
  }

  const targetRowIndex = selectedRowIndex + direction;
  const targetRowId = getVisibleRowIds(apiRef).find(
    (rowId) => apiRef.current.getRowIndexRelativeToVisibleRows(rowId) === targetRowIndex
  );

  if (targetRowId) {
    apiRef.current.setRowSelectionModel([targetRowId]);
    apiRef.current.scrollToIndexes({ colIndex: 0, rowIndex: targetRowIndex + direction });
  }
};

export const setAllNonGroupRowsSelection = (gridApi: GridApiPremium, isSelected: boolean) => {
  const childRows = gridApi.getAllRowIds();
  gridApi.selectRows(childRows, isSelected);
};

export const getVisibleRowIds = (apiRef: RefObject<GridApiPremium>) => gridExpandedSortedRowIdsSelector(apiRef);

export const getAllRowIds = (apiRef: RefObject<GridApiPremium>) => gridFilteredSortedRowIdsSelector(apiRef);

export const isAnyGroupExpanded = (apiRef: RefObject<GridApiPremium>) => {
  return getVisibleRowIds(apiRef).some((id) => {
    const rowNode = apiRef.current.getRowNode(id);
    return rowNode?.type === "group" && rowNode.childrenExpanded;
  });
};

export const setAllGroupsExpansion = (apiRef: RefObject<GridApiPremium>, isExpanded: boolean) => {
  getAllRowIds(apiRef).forEach((rowId) => {
    if (apiRef.current.getRowNode(rowId)?.type === "group") {
      apiRef.current.setRowChildrenExpansion(rowId, isExpanded);
    }
  });
};

export const checkSelection = (apiRef: RefObject<GridApiPremium>) => {
  const children = apiRef.current.getAllRowIds(); // returns only non-auto-generated row IDs
  const selectionLookup = selectedIdsLookupSelector(apiRef.current.state, apiRef.current.instanceId);

  const indeterminate =
    children?.some((child) => selectionLookup[child] === undefined) &&
    children?.some((child) => selectionLookup[child] !== undefined);

  const checked = children.length > 0 && children?.every((child) => selectionLookup[child] !== undefined);
  return { children, indeterminate, checked };
};
